import React from 'react';
import { Dropdown } from 'semantic-ui-react';

import EliminarGastoDiario from './EliminarGastoDiario';
interface Props {
    idGastoDiario: string;
    alModificarGastos(): void;
}

const Acciones: React.FunctionComponent<Props> = props => {
    const { idGastoDiario, alModificarGastos } = props;

    return (
        <Dropdown icon='ellipsis vertical' pointing='top right'>
            <Dropdown.Menu>
                <EliminarGastoDiario
                    idGastoDiario={idGastoDiario}
                    alModificarGastos={alModificarGastos}
                />
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default Acciones;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Gastos/componentes/Acciones.tsx